import React from 'react';
import { useCart } from '@shopify/hydrogen-react';
import { Button } from '@material-tailwind/react';
import { useRouter } from 'next/router';

interface CheckoutButtonProps {
  className?: string;
  disabled?: boolean;
  successUrl?: string;
  cancelUrl?: string;
  returnUrl?: string;
}

export default function CheckoutButton({ 
  className = '',
  disabled = false,
  successUrl,
  cancelUrl,
  returnUrl
}: CheckoutButtonProps) {
  const { lines, totalQuantity, status, checkoutUrl, cartAttributesUpdate } = useCart();
  const router = useRouter();

  const handleCheckout = async () => {
    // Check if cart has items
    if (!lines || lines.length === 0) {
      console.warn('Cannot checkout with empty cart');
      return;
    }

    try {
      // Get current URL for default redirects
      const currentUrl = window.location.origin + router.asPath;
      const baseUrl = window.location.origin;

      // Prepare cart attributes with redirect URLs
      const attributes = [
        {
          key: 'success_url',
          value: successUrl || `${baseUrl}/account/subscribed/result?status=success`
        },
        {
          key: 'cancel_url', 
          value: cancelUrl || currentUrl
        },
        {
          key: 'return_url',
          value: returnUrl || `${baseUrl}/shop`
        }
      ];

      // Update cart attributes
      await cartAttributesUpdate(attributes);

      // Proceed to checkout
      if (checkoutUrl) {
        window.location.href = checkoutUrl;
      } else {
        console.error('No checkout URL available');
        alert('There was an error processing your checkout. Please try again.');
      }
    } catch (error) {
      console.error('Error updating cart attributes:', error);
      // Still proceed to checkout even if attributes update fails
      if (checkoutUrl) {
        window.location.href = checkoutUrl;
      } else {
        alert('There was an error processing your checkout. Please try again.');
      }
    }
  };

  const isDisabled = disabled || 
                    status === 'updating' || 
                    !lines || 
                    lines.length === 0 || 
                    totalQuantity === 0 ||
                    !checkoutUrl;

  return (
    <Button
      onClick={handleCheckout}
      disabled={isDisabled}
      className={`bg-scpb-light-blue hover:bg-blue-700 ${className}`}
    >
      Checkout
    </Button>
  );
}
